export default __webpack_public_path__ + "static/media/firebase.bd375a2d.svg";